// Utilities
import { gcAccessToken, gcEnvironment, fetchWrap } from '../../components/common/utilities/fetchWrap';
import config from '../../config';

/**
* @async
* @description Get's the current integration types from genesys cloud api.
* @return {Promise<object>} { data, count, correlationIds, httpResults }
*/
export const addOAuthClient = async (oauthName: string, roles: []) => {
  const urlbase = config.endpoints.endpoint;
  const url = `${urlbase}/createRoleAndOAuthClient`;
  const token = gcAccessToken();
  const gcEnv = gcEnvironment();
  const payload = {
      oauthName,
      roles
  }
  return await fetchWrap(
    {url,
    options: {
      method: "POST",
      body: JSON.stringify(payload)
    },
    token,
    auth: true,
    cookies: false,
    headerOptions: {
      token: token,
      env: gcEnv,
    }
  }
  );
}

export const fetchRolesAndPermissions = async (clientId: string) => {
  const urlbase = config.endpoints.endpoint;
  const url = `${urlbase}/fetchRolesAndPermissions`;
  const token = gcAccessToken();
  const gcEnv = gcEnvironment();
  const payload = {
      clientId
  }
  return await fetchWrap(
    {url,
    options: {
      method: "POST",
      body: JSON.stringify(payload)
    },
    token,
    auth: true,
    cookies: false,
    headerOptions: {
      token: token,
      env: gcEnv,
    }
  }
  );
}

const createRoleAndOAuthClientService = {addOAuthClient, fetchRolesAndPermissions};

export default createRoleAndOAuthClientService;